// extracted by mini-css-extract-plugin
export default {"caret":"InputOTP_caret__KYULK","caret-blink":"InputOTP_caret-blink__xfjqr","slot":"InputOTP_slot__9UqZF","separator":"InputOTP_separator__gXi-7"};